import typia from "typia";
import { validate as v } from "CoreUtils";

import { SchematicChange as SchChange } from "./schematic/change";
import { LayoutChange as LayChange } from "./layout";
import { SymbolChange as SymChange } from "./symbol/change";

// Re-export the change types
export type SchematicChange = SchChange;
export const SchematicChange = SchChange;

export type LayoutChange = LayChange;
export const LayoutChange = LayChange;

export type SymbolChange = SymChange;
export const SymbolChange = SymChange;

export type Change = SchematicChange | LayoutChange | SymbolChange;

export const Change = {
  Schematic: SchematicChange,
  Layout: LayoutChange,
  Symbol: SymbolChange,
  validator: new v.Validator(v.createValidate<Change>()),
  stringify: typia.json.createStringify<Change>(),
};
